<template>
  <div class="h-100">
    <div v-if="!loading" class="auth-wrapper auth-v1">
      <div class="auth-inner">
        <b-card class="m-0 pt-1 h-100">
          <!-- Brand -->
          <div class="d-flex justify-content-center">
            <b-img src="@/assets/images/logo/default.png" alt="logo" style="width: 100px; height: 100px;" />
          </div>
          <div class="brand-logo w-100 flex-column align-items-center justify-content-center">
            <h1 class="brand-text text-primary">پنل منوتِک</h1>
          </div>
          <!-- /Brand -->
          <div v-if="loginWithOtp" class="px-1">
            <b-card-text class="text-primary-middle mb-2 font-weight-bolder">شماره همراه خود را وارد کنید</b-card-text>

            <!-- form -->
            <validation-observer ref="loginValidation" #default="{ invalid }">
              <b-form class="auth-login-form" @submit.prevent>
                <!-- phone number -->
                <b-form-group label="شماره همراه" label-for="login-phonenumber">
                  <validation-provider #default="{ errors }" name="شماره همراه" rules="required|phoneNumber">
                    <b-form-input inputmode="numeric" dir="ltr" id="login-phonenumber" v-model="userMobile"
                      :class="{ 'font-weight-bolder': !!userMobile }" :state="errors.length > 0 ? false : null"
                      name="login-phonenumber" class="text-center text-primary-middle py-2" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <p v-if="hasStore" class="text-warning">
                  لطفاً برای فعال کردن حساب، به صفحه
                  <a href="https://menutech.ir/buy-subscription">خرید اشتراک</a>
                  مراجعه کنید.
                </p>
                <!-- submit buttons -->
                <b-button type="submit" variant="primary" block @click="validationForm"
                  :disabled="invalid || buttonLoading"
                  class="d-flex align-items-center justify-content-center mt-2 mb-1 py-1">
                  <span style="font-size: 16px;">دریافت کد اعتبارسنجی</span>
                  <b-spinner v-if="buttonLoading" variant="white" class="ml-50" small></b-spinner>
                </b-button>
              </b-form>
            </validation-observer>
            <div class="text-center">
              ورود، به معنای پذیرش
              <span v-b-modal.modal-rules class="text-primary pointer">
                توافق نامه منوتِک
              </span>
              است
            </div>
            <div @click="changeLoginMode" class="text-info pointer text-center mt-2 py-50">
              <span>ورود با نام کاربری</span>
            </div>
          </div>
          <div v-else class="px-1">
            <b-card-text class="text-primary-middle mb-2 font-weight-bolder">نام کاربری و رمز عبور خود را وارد
              کنید</b-card-text>

            <b-form @submit.prevent>
              <!-- username -->
              <b-form-group label="نام کاربری" label-for="login-username">
                <b-form-input dir="ltr" v-model="loginData.username" id="login-username"
                  class="text-center text-primary-middle py-2" />
              </b-form-group>

              <!-- password -->
              <b-form-group>
                <label for="login-password">رمز عبور</label>
                <b-input-group class="input-group-merge">
                  <b-form-input dir="ltr" v-model="loginData.password" id="login-password"
                    class="text-center text-primary-middle py-2 pl-3" :type="passwordFieldType" />
                  <b-input-group-append is-text>
                    <feather-icon :icon="passwordToggleIcon" class="cursor-pointer" @click="togglePasswordVisibility" />
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>


              <b-button type="submit" variant="primary" block @click="login"
                :disabled="buttonLoading || !loginData.password || !loginData.username"
                class="d-flex align-items-center justify-content-center mt-2 mb-1 py-1">
                <span style="font-size: 16px;">ورود به پنل</span>
                <b-spinner v-if="buttonLoading" class="ml-50" variant="white" small></b-spinner>
              </b-button>
            </b-form>
            <div class="text-center">
              ورود، به معنای پذیرش
              <span v-b-modal.modal-rules class="text-primary pointer">
                توافق نامه منوتِک
              </span>
              است
            </div>
            <div @click="changeLoginMode" class="text-info pointer text-center mt-2 py-50">
              ورود با شماره همراه
            </div>
          </div>
        </b-card>
      </div>
      <b-modal id="modal-rules" title="توافق نامه منوتِک" size="lg" centered :hide-footer="true"
        title-class="font-weight-bolder">
        <b-card-text class="mt-50">
          <div>
            <div v-for="(item, index) in rules" :key="`rules${index}`" class="mb-2">
              <h4>{{ item.title }}</h4>
              <p v-for="(description, index) in item.descriptions" :key="`description_${index}`">{{ description }}</p>
            </div>
          </div>
        </b-card-text>
      </b-modal>
    </div>
    <loading class="d-flex justify-content-center align-items-center h-100" v-if="loading" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { BIconX, BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BInputGroupPrepend, BFormCheckbox, BCard, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner } from 'bootstrap-vue';
import { required, phoneNumber } from '@validations';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import store from '@/store/index';
import jwt_decode from "jwt-decode";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BSpinner,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BInputGroupPrepend,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BIconX,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userMobile: '',
      loading: false,
      loginWithOtp: false,
      loginData: {
        username: null,
        password: null,
      },
      buttonLoading: false,
      sideImg: require('@/assets/images/pages/login.svg'),
      required,
      phoneNumber,
      rules: [
        {
          title: 'موضوع توافق نامه',
          descriptions: [
            'موضوع این توافق نامه عبارت است از ارائه خدمات نرم‌افزاری تحت وب از طریق پلتفرم منوتِک در قالب پکیج‌های اشتراکی که جزئیات و امکانات آن در صفحه menutech.ir/buy-subscription درج شده و همواره به‌روزرسانی می‌شود.',
          ]
        },
        {
          title: 'مدت توافق نامه',
          descriptions: [
            'مدت زمان اشتراک براساس انتخاب مشترک در وب‌سایت رسمی منوتِک به نشانی menutech.ir/buy-subscription تعیین می‌شود. شایان ذکر است که کلیه جزئیات مربوط به اشتراک‌های خریداری‌شده، از جمله اشتراک فعال، از طریق پنل کاربری به نشانی panel.menutech.ir قابل دسترسی خواهد بود.',
            'در صورت عدم تمدید اشتراک توسط مشترک، خدمات تا تاریخ پایان دوره اشتراک معتبر بوده و پس از آن ارائه خدمات متوقف خواهد شد.',
          ]
        },
        {
          title: 'مبلغ توافق نامه و نحوه پرداخت',
          descriptions: [
            'مبلغ توافق نامه براساس هزینه‌های اشتراک انتخابی مشترک که در صفحه menutech.ir/buy-subscription به تفصیل ذکر شده، تعیین می‌شود. مشترک می‌تواند در هر زمان از طریق پنل اقدام به تمدید یا ارتقا اشتراک نماید.',
            'مشترک می‌تواند از طریق پنل کاربری و با پرداخت مبلغ تعیین‌شده، نسبت به ارتقا یا تمدید اشتراک خود اقدام نماید. هرگونه تمدید یا ارتقا اشتراک از طریق پنل و پرداخت آنلاین، به منزله تمدید و تأیید توافق نامه خواهد بود. در صورت ارتقا به پکیج بالاتر، مبلغ مابه‌التفاوت با توجه به مدت ‌زمان استفاده‌ شده محاسبه خواهد شد.',
            'هزینه تمدید در هر سال بر اساس نرخ رشد تورم اعلامی بانک مرکزی و افزایش معقول هزینه‌های جاری، قابل افزایش توسط منوتِک خواهد بود.',
          ]
        },
        {
          title: 'تعهدات طرفین',
          descriptions: [
            'منوتِک متعهد است تا خدمات مطابق با پکیج انتخابی را در مدت زمان اشتراک ارائه دهد.',
            'منوتِک متعهد است آموزش‌های لازم جهت راه‌اندازی و استفاده از پنل مدیریت را به مشترک انتقال داده و هرگونه سوال یا مشکلی در خصوص استفاده از نرم‌افزار را برطرف نماید.',
            'منوتِک متعهد است در صورت بروز هرگونه خطا یا مشکل احتمالی که منجر به اختلال در نرم‌افزار شود، در اسرع وقت نسبت به رفع آن اقدام نماید.',
            'منوتِک مسئولیت پایداری سرویس را برعهده دارد؛ اما اختلالات ناشی از زیرساخت‌های غیرمرتبط (اینترنت داخلی یا بین‌المللی) از مسئولیت منوتِک خارج است.',
            'منوتِک متعهد است تمامی اطلاعات، داده‌ها، و محتواهای مشترک را مطابق با مقررات قانون تجارت الکترونیک و اصول حفاظت از داده‌های شخصی ذخیره و محافظت نماید.',
            'منوتِک متعهد می‌شود که داده‌های شخصی، اطلاعات فنی، تجاری و سایر اطلاعات حساس مشترک که در جریان اجرای توافق نامه دریافت می‌کند را کاملاً محفوظ نگه داشته و از افشای آنها به اشخاص ثالث جلوگیری کند.',
            'مشترک متعهد است کلیه فعالیت‌های خود از جمله بارگذاری محتوا در سامانه را مطابق با قوانین جمهوری اسلامی ایران، از جمله قانون جرایم رایانه‌ای و سایر مقررات مرتبط، انجام دهد و مسئولیت کامل در این زمینه بر عهده وی خواهد بود.',
            'مشترک موظف است در حفظ و نگهداری رمز عبور پنل خود کوشا باشد.',
            'مشترک موظف است به‌صورت مستقل تغییرات لازم در بارگذاری محصولات و ساخت منو را انجام دهد و منوتِک در این زمینه تعهدی ندارد.',
            'مشترک متعهد است کلیه هزینه‌های مقرر را صرفاً از طریق درگاه پرداخت بانکی موجود در پنل کاربری به نشانی panel.menutech.ir  به‌صورت آنلاین پرداخت و تسویه نماید.',
            'در صورت عدم تمدید اشتراک حداکثر تا ۶ روز پس از پایان دوره، کلیه اطلاعات مشترک از سرورهای منوتِک حذف خواهد شد. این اقدام در راستای الزامات حفظ حریم خصوصی و امنیت اطلاعات مشترک صورت می‌پذیرد. ',
            'مشترک متعهد است که از اطلاعات و امکانات پنل ارائه‌شده تنها به منظور اجرای این توافق نامه استفاده کند و از افشای آن به اشخاص ثالث خودداری نماید.',
            'در صورت وقوع حوادثی غیرقابل پیش‌بینی، غیرقابل اجتناب و خارج از اراده طرفین که مانع از اجرای تعهدات هریک از طرفین گردد، نظیر جنگ، زلزله، حملات سایبری (هک شدن سایت)، قطع اینترنت داخلی یا بین‌المللی و سایر موارد مشابه که ارائه خدمات را غیرممکن سازد و خارج از کنترل طرفین باشد، طرفین از انجام تعهدات مندرج در این توافق نامه معاف خواهند بود.',
          ]
        },
        {
          title: 'خدمات پیامکی و درگاه پرداخت',
          descriptions: [
            'خدمات ارسال پیامک برای مشتریان مجموعه (مشترک) مشمول هزینه می‌باشد و در صورت نیاز به استفاده از این خدمات، مشترک موظف است بسته‌ی موردنظر را بر اساس نیاز خود از طریق پنل خریداری نماید.',
            'در صورت استفاده از خدمات فروش آنلاین، کارمزد 0.2 درصد از هر تراکنش به‌عنوان هزینه خدمات پرداخت کسر می‌گردد. کارمزد ممکن است مطابق با قوانین بانک مرکزی ایران تغییر کند.',
            'پرداخت‌ها و انتقال وجوه تحت نظارت قوانین و مقررات بانک مرکزی جمهوری اسلامی ایران و با رعایت استانداردهای امنیتی انجام می‌شود و مبالغ به‌صورت مستقیم به شماره شبای اعلام‌شده توسط مشترک در پنل مدیریت واریز می‌گردد.',
          ]
        },
      ],
      hasStore: false,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        this.sideImg = require('@/assets/images/pages/login.svg');
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.sendCode();
        }
      });
    },
    changeLoginMode() {
      this.loginWithOtp = !this.loginWithOtp
      this.loginData.password = null;
      this.loginData.username = null;
      this.userMobile = '';
    },
    sendCode() {
      this.buttonLoading = true;
      this.$auth.sendCode({ phoneNumber: this.userMobile, }).then((res) => {
        this.$auth.$storage.setLocalStorage('loginMobile', this.userMobile);
        this.$router.push('/verify');
      })
        .catch(({ response }) => {
          this.buttonLoading = false;
          if (response.data.errors[0].code == 'UserIsNotInStore') {
            this.hasStore = true
          }
          else {
            this.hasStore = false
          }
        })
    },
    async login() {
      try {
        this.buttonLoading = true;
        await this.$auth
          .login(this.loginData)
          .then((res) => {
            setTimeout(() => {
              this.$router.push('/');
            }, 850)
          })
          .catch(() => {
            this.buttonLoading = false;
          });
      }
      catch (err) {

      }
    },
    async getUserInfo(token) {
      await this.$auth
        .getUserInfo(token)
        .then((res) => {
          setTimeout(() => {
            this.$router.push('/');
          }, 850)
        })
    },
    async refreshToken(refreshTokenData) {
      this.loading = true
      await this.$axios.post('/Auth/RefreshToken', { refreshToken: refreshTokenData }).then((data) => {
        let accessToken = data.data.accessToken
        let refreshToken = data.data.refreshToken
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        const decodedJwt = jwt_decode(accessToken);
        localStorage.setItem("storeId", decodedJwt.storeid);
        let token = {
          accessToken: accessToken,
          refreshToken: refreshToken
        }
        this.getUserInfo(token);
      })
        .catch((err) => {

        });
    },
  },

  mounted() {
    if (this.$route.query.refreshToken) {
      this.refreshToken(this.$route.query.refreshToken)
    }
    else {
      if (this.$route.query.password) {
        this.loginData.username = this.$route.query.username
        this.loginData.password = this.$route.query.password
        this.loading = true
        this.login()
      }
      else {
        let accessToken = localStorage.getItem("accessToken")
        if (accessToken) {
          this.$router.push('/');
        }
      }
    }
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
